<template>
    <ui-modal
        :class="{'has-right-aside' : layout.showDeals}"
        name="simulation-client"
        title="Selecionar Cliente"
        icon="fal fa-user-circle"
        size="xs" 
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad">
        
        <template #right>
            <transition name="aside">
                <div v-show="layout.showDeals" class="aside" :class="{'show' : layout.showDeals}">
                    <!-- <div class="aside" slot="right"> -->
                    <div class="aside-header">
                        <div>
                            <i class="fal fa-handshake"/>
                            <span>Negócios</span>
                        </div>
                        <button class="button-close" type="button" @click="closeDeals"><i class="fal fa-times" aria-hidden="true"/></button>
                    </div>
                    <div class="aside-content" >
                        <ui-select-deal
                            v-if="dealsComputed && form.client.data"
                            v-model="dealsComputed"
                            :default="currentDeal ? currentDeal.id : null"
                            :client="form.client.data"
                            :load="loader.deals" />
                    </div>
                    <div class="aside-footer">
                        <ui-button design="link" @click="close">Cancelar</ui-button>
                        <ui-button
                            v-if="layout.showButtonSubmit"
                            :loading="loader.buttonSubmit"
                            design="lg success mw-100"
                            @click="submit">
                            Avançar <i class="fal fa-long-arrow-right" />
                        </ui-button>
                    </div>
                </div>
            </transition>
        </template>

        <div class="modal">
            <div class="modal-body">
                <div v-if="!layout.showForm" class="load-indicator">
                    <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                </div>

                <div v-else>
                    <div class="form-search">
                        <!-- 
                        /**
                         * Quando o USER for administrador tem que mostar o campo de filtro por CORRETOR
                         */ -->

                        <ui-select-v2
                            v-if="layout.showFilterByBroker"
                            v-model="form.client.params.broker"
                            label="Filtrar clientes por corretor"
                            :data="brokerSelect.options"
                            :loading="loader.brokerSelect"
                            :search="true"
                            :text-items="textItemsList"
                            :before-text-item="beforeTextItems"
                            search-event="brokers"
                            cover="logo"
                            align="normal"
                            item-label="first_name"
                            return-value="broker_id"
                            ajax-search
                            @input="brokerSelectHandler"
                        />

                        <ui-search-box placeholder="Digite o nome, cpf ou e-mail do cliente" event="client-search"/>

                    </div>

                    <ui-select-client
                        v-model="clientsComputed"
                        :default="currentClient ? currentClient.id_customer : null"
                        :load="loader.clients"
                        :total="form.client.params.total"
                        @add-new-client="addNewClient"
                        @load-more="loadMoreClients"/>
                </div>
            </div>
 
            <div class="modal-footer">
                <div class="buttons"> 
                    <ui-button design="link" @click="close">Cancelar</ui-button>
                    <ui-button
                        v-if="layout.showButtonAddNewClient"
                        design="md primary mw-100"
                        @click="addNewClient">
                        <i class="fal fa-plus"/> Novo Cliente
                    </ui-button>
                    <ui-button
                        v-if="layout.showButtonSubmit"
                        :loading="loader.buttonSubmit"
                        design="md success mw-100"
                        @click="submit">
                        Avançar <i class="fal fa-long-arrow-right"/>
                    </ui-button>
                </div>
            </div>
        </div>

    </ui-modal> 
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"
    import { uiModal } from "@/components/ui/modal"
    import { uiSelectV2 } from "@/components/ui/form"
    import { uiLoadIndicator, uiSearchBox } from '@/components/ui'
    import uiSelectClient from '@/components/ui-facilita/sales/select-client'
    import uiSelectDeal from '@/components/ui-facilita/sales/select-deal'
    import helpers from '@/mixins/helpers'
    
    import {
        customer,
        deal,
        team,
        configuration
    } from '@/services/axios'
    import { storage } from "@/services/storage"

    import { mapGetters } from 'vuex'
    import axios from 'axios'

    const defaultLayout = () => {
        return {
            showForm: false,
            showDeals: false,
            showButtonSubmit: false,
            showFilterByBroker: false,
            showButtonAddNewClient: true,
        }
    }

    const defaultLoader = () => {
        return {
            clients: false,
            deals: false,
            editingForm: false,
            modalLoad: false,
            modalLoadSuccess: false,
            selectClient: false,
            buttonSubmit: false,
            brokerSelect: false,
        }
    }

    const defaultNames = () => ({
        admin: storage.get('label_admin'),
        collaborator: storage.get('label_collaborator'),
        supervisor: storage.get('label_supervisor'),
        manager: storage.get('label_manager'),
        broker: storage.get('label_broker'),
    })

    const defaultBrokerSelect = () => ({
        options: [],
        pagination: {
            page: 1,
            last_page: 0,
            per_page: 25,
            total: 0,
            search: ''
        }
    })

    const defaultForm = () => ({
        client: {
            data: null,
            params: {
                q: '',
                page: 1,
                per_page: 25,
                broker: null,
                complete: true,
                total: 0
            }
        },
        deal: {
            data: null
        },
        config: {
            funnel_stage_id: null,
            funnel_stage_status_id: null
        }
    })

    export default {
        name: 'ui-client-select-modal',

        components: {
            uiButton,
            uiModal,
            uiSearchBox,
            uiLoadIndicator,
            uiSelectV2,
            uiSelectClient,
            uiSelectDeal,
        },

        mixins: [helpers],

        data() {
            return {
                layout: {
                    showForm: false,
                    showDeals: false,
                    showButtonSubmit: false,
                    showFilterByBroker: false,
                    showButtonAddNewClient: true,
                },
                loader: { ...defaultLoader() },
                clients: [],
                deals: null,
                form: { ...defaultForm() },
                names: { ...defaultNames() },
                textItemsList: [ 'group_name','email',],
				beforeTextItems: [ 'Grupo:', 'E-mail:'],
                brokerSelect: { ...defaultBrokerSelect() },
                cancelToken: null
            }
        },

        computed: {
            ...mapGetters({
                currentClient: 'simulation/getCustomer',
                currentDeal: 'simulation/getCustomerDeal',
                product: 'simulation/getProduct',
                proposedValue: 'simulation/getProposedValue',
                user: 'auth/getUser'
            }),

            /**
             * Computed property que filtra ou não as unidades de acordo com a situação e
             * o switch de configuração
             */
            clientsComputed: {
                get() {
                    return this.clients
                },
                set(value) {
                    this.$set(this.form.client, 'data', value)
                    if (value) {
                        /**
                         * Mostrar a extensão do modal para selecionar o negócio
                        */
                       this.loadDeals()
                    } else {
                        this.$set(this.layout, 'showButtonSubmit', false)
                        this.$set(this.layout, 'showButtonAddNewClient', true)
                    }
                }
            },

            /**
             * Computed property para calcular o total de páginas de acordo com o total
             * de itens na listagem
            */
            totalPages() {
                let quotient = Math.floor(this.form.client.params.total / this.form.client.params.per_page)
                let remainder = this.form.client.params.total % this.form.client.params.per_page
                return remainder === 0 ? quotient : quotient + 1
            },

            /**
             * Computed property que controla a seleção do negócio do cliente
             */
            dealsComputed: {
                get() {
                    return this.deals
                },
                set(value) {
                    this.$set(this.form.deal, 'data', value)
                    this.$set(this.layout, 'showButtonSubmit', true)
                }
            },
        },

        mounted() {
            this.$root.$on('client-search', (query) => {
                this.$set(this.form.client.params, 'page', 1)
                this.$set(this.form.client.params, 'total', 0)
                this.$set(this.form.client.params, 'q', query)
                this.loadClients()
            })

            /**
             * Ao abrir o modal faz o start no carregamento dos clientes;
             * Os paramentros de loadings e laytout são resetados
             */
            this.$root.$on('modal-open-simulation-client', async () => {
                this.resetLayout()
                this.resetLoader()
                this.loadForm()
                await this.loadClients()
			})

            this.$root.$on('select-v2-ajax-search-brokers', (payload) => {
                const pagination = { ...this.brokerSelect.pagination }
                // Define os parâmetros de paginação e filtragem de acordo com o payload do select
                if (payload.nextPage) {
                    if (pagination.page < pagination.last_page) {
                        this.brokerSelect.pagination.page += 1

                    // Caso a última página já tenha sido listada, não permite mais requisições de paginação
                    } else if (pagination.page === pagination.last_page) {
                        return
                    }

                } else {
                    this.brokerSelect.pagination.page = 1
                    this.brokerSelect.pagination.last_page = 0
                    this.brokerSelect.pagination.total = 0
                    this.brokerSelect.options = []
                    this.loader.brokerSelect = false
                }
                this.brokerSelect.pagination.search = payload.search

                this.loadBrokers()
            })
        },

        beforeDestroy() {
            this.$root.$off('client-search')
            this.$root.$off('client-by-broker-search')
            this.$root.$off('modal-open-simulation-client')
            this.$root.$off('select-v2-ajax-search-brokers')
        },

        methods: {
            /**
             * Reseta o layout
             */
            resetLayout() {
                this.layout = {
                    ...defaultLayout()
                }
            },

            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = {
                    ...defaultLoader()
                }
            },

            /**
             * Limpa os dados do formulário e carrega as configurações necessárias
             */
            loadForm() {
                this.form = { ...defaultForm() }
                this.deals = null
                this.clients = []
                this.brokerSelect = { ...defaultBrokerSelect() }

                if (this.user.user_group !== 'broker') {
                    this.loadBrokers()
                    this.layout.showFilterByBroker = true
                }

                /** Carrega as configurações do formulário */
                configuration.getConfigurations().then(response => {
                    let data = response.data
                    for (var prop in data) {
                        if(Object.prototype.hasOwnProperty.call(data, prop)) {
                            switch (data[prop].name) {                                
                                case 'proposalSettings':
                                    var config = data[prop].value_long
                                    if (config && config.simulation && config.simulation.funnel_start) {
                                        this.form.config.funnel_stage_id = config.simulation.funnel_start.stage_id
                                        this.form.config.funnel_stage_status_id = config.simulation.funnel_start.status_id
                                    }
                                    break
                            }
                        }
                    }
                })
            },

            /**
             * Carrega a lista de clientes
             */
            loadClients() {
                this.$set(this.loader, 'clients', true)
                this.$set(this.layout, 'showDeals', false)
                this.$set(this.layout, 'showButtonSubmit', false)

                /**
                 * Faz o carregamento dos clientes
                 */
                customer.getAll('', this.form.client.params)
                    .then(response => {
                        if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
                            if (response.data.from !== 1 && response.data.total) {
                                this.clients = this.clients.concat([...response.data.data])
                            } else {
                                this.clients = [...response.data.data]
                            }
                            this.$set(this.form.client.params, 'total', response.data.total)

                        } else {
                            this.clients = [...response.data]
                            this.$set(this.form.client.params, 'total', response.data.length)
                        }

                        this.$nextTick(() => {
                            this.$set(this.layout, 'showForm', true)
                            this.$set(this.loader, 'clients', false)
                        })
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)
                    })
            },

            /**
             * Carrega a lista de clientes
             */
            loadDeals() {
                this.$set(this.loader, 'deals', true)
                this.$set(this.layout, 'showDeals', false)
                this.$set(this.layout, 'showButtonSubmit', false)
                this.$set(this.layout, 'showButtonAddNewClient', false)
                this.deals = null

                if (this.form.client.data && (!this.currentClient ||
                    (this.currentClient && this.currentClient.id_customer !== this.form.client.data.id_customer))) {
                    deal.get(this.form.client.data.id_customer, '/active')
                        .then(response => {
                            /**
                             * Caso o cliente possua apenas um cliente, seleciona-se este e continua o fluxo,
                             * todavia se este não possua um negócio configura para que durante o fluxo um novo
                             * negócio seja criado
                             */
                            if (response.data.length <= 1) {
                                this.$set(this.form.deal, 'data', response.data.length ? response.data[0] : { id: 'newDeal' })
                                this.$set(this.layout, 'showButtonSubmit', true)

                            } else {
                                this.deals = [...response.data]
                                this.$set(this.layout, 'showDeals', true)
                                this.$set(this.layout, 'showButtonAddNewClient', true)
                            }

                            this.$set(this.loader, 'deals', false)
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            this.$set(this.loader, 'deals', false)
                            this.$set(this.layout, 'showButtonAddNewClient', true)
                            console.log(error)
                        })

                } else {
                    if (this.currentDeal) this.$set(this.form.deal, 'data', this.currentDeal)
                    this.$set(this.loader, 'deals', false)
                    this.$set(this.layout, 'showButtonSubmit', true)
                }
            },

            /**
             * Fechar o modal, e mostrar a tela do simulador enviar os dados do modal para a tela
             */
            submit() {
                this.$set(this.layout, 'showDeals', false)
                this.$set(this.loader, 'modalLoad', true)

                /** Caso seja selecionado para criar um novo negócio para o cliente */
                if (this.form.client.data && this.form.deal.data && this.form.deal.data.id === 'newDeal') {
                    // Chama o modal para selecionar a origem do deal
                    const sendData = {
                        customer_id: this.form.client.data.id_customer,
                        product_id: this.product ? this.product.id : null,
                        cost: this.proposedValue,
                        funnel_stage_id: this.form.config.funnel_stage_id || null,
                        funnel_stage_status_id: this.form.config.funnel_stage_status_id || null,
                        broker_id: this.form.client.data.owners.broker_id,
                        manager_id: this.form.client.data.owners.manager_id,
                        team_id: this.form.client.data.owners.team_id,
                    }

                    this.$set(this.loader, 'modalLoadSuccess', true)
                    this.close()

                    this.$root.$emit('modal-open-select-origin-for-deal', { deal: sendData, client: this.form.client.data })

                } else {
                    this.$emit('selected', {
                        client: this.form.client.data,
                        deal: this.form.deal.data
                    })

                    setTimeout(() => {
                        this.$set(this.loader, 'modalLoadSuccess', true)
                        setTimeout(() => {
                            this.close()
                        }, 404)
                    }, 404)
                }
            },

            /**
             * Adicionar novo cliente
             * Emite evento para o componente Simulador aonde abre-se o componente de adicionar o cliente
             */
            addNewClient() {
                this.$root.$emit('modal-close-simulation-client')
                this.$root.$emit('modal-open-create-deal-modal', { type: 'simulation' })
            },
            
            /**
             * Fecha a listagem de negócios
             */
            closeDeals() {
                this.$set(this.layout, 'showButtonAddNewClient', !this.form.client.data)
                this.$set(this.layout, 'showButtonSubmit', !!this.form.deal.data)
                this.$set(this.layout, 'showDeals', false)
            },

            /**
             * Emite um evento no root para fechar o modal e volta para o último histórico
             */
            close() {
                this.$root.$emit('modal-close-simulation-client')
            },

            /**
             * Handler para o evento de quando os clientes são filtrados por corretor
             */
            brokerSelectHandler() {
                this.$set(this.form.client.params, 'page', 1)
                this.$set(this.form.client.params, 'total', 0)
                this.loadClients()
            },

            /**
             * Evento disparado ao fazer scroll dos clientes - INFINITE SCROLL
             */
            loadMoreClients() {
                const oldPage = this.form.client.params.page
                const page = this.form.client.params.page + 1
                if (page > 0 && page <= this.totalPages) {
                    this.$set(this.form.client.params, 'page', page)
                } else if (this.totalPages) {
                    this.$set(this.form.client.params, 'page', this.totalPages)
                } else {
                    this.$set(this.form.client.params, 'page', 1)
                }

                /** Apenas carrega os itens se a página ainda não foi carregada */
                if (oldPage !== this.form.client.params.page) this.loadClients()
            },
            /**
             * Carrega as opções do select de brokers, de acordo com os parâmetros de paginação
             */
            loadBrokers() {
                if (this.cancelToken) this.cancelToken.cancel()

                this.loader.brokerSelect = true
                this.cancelToken = axios.CancelToken.source()
                const params = { ...this.brokerSelect.pagination }
                team.getAll('brokers', params, { cancelToken: this.cancelToken.token })
                    .then(response => {
                        this.brokerSelect.options = [
                            ...this.brokerSelect.options,
                            ...Object.values(response.data.data).map(option => {
                                option.group_name = this.names[option.groupLabel]
                                option.cover = this.getImgCDN(option.logo)

                                return option
                            })
                        ]
                        this.brokerSelect.pagination.last_page = response.data.last_page
                        this.brokerSelect.pagination.total = response.data.total
                        this.cancelToken = null
                        this.loader.brokerSelect = false
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log('error', error)

                        if (!axios.isCancel(error)) {
                            this.cancelToken = null
                            this.loader.brokerSelect = false
                        }
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>